import React from 'react';
import { Flame } from 'lucide-react';

// Stable per product and per day, between 15 and 84
export const viewersFor = (id = '') => {
  const seed = `${id}-${new Date().toISOString().slice(0, 10)}`;
  let h = 0;
  for (let i = 0; i < seed.length; i += 1) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return 15 + (h % 70);
};

export const ViewersBadge = ({ garmentId, compact = false }) => {
  const n = viewersFor(garmentId);
  if (compact) {
    return (
      <span className="absolute bottom-2 left-2 right-2 bg-white/95 text-[10px] sm:text-[11px] px-2 py-1 flex items-center gap-1 pointer-events-none transition-opacity group-hover:opacity-0" data-testid={`viewers-badge-${garmentId}`}>
        <Flame className="w-3 h-3 text-orange-500 fill-orange-400 shrink-0" />
        <span className="truncate"><strong>{n}</strong> <span className="text-neutral-500">vieron esto hoy</span></span>
      </span>
    );
  }
  return (
    <span className="absolute bottom-4 left-4 right-4 bg-white/95 text-xs sm:text-sm px-3 sm:px-4 py-2.5 flex items-center justify-center gap-2 pointer-events-none" data-testid="viewers-badge">
      <Flame className="w-4 h-4 text-orange-500 fill-orange-400 shrink-0" />
      <span><strong>{n}</strong> <span className="text-neutral-500">personas vieron esto en las últimas 24 horas</span></span>
    </span>
  );
};
